import { Box, IconButton, SxProps } from '@mui/material';
import { Input, Props as InputProps } from './Input';
import SearchIcon from '@mui/icons-material/Search';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { Loading } from 'components/Loading';

export type SearchInputProps = InputProps & {
  onClear: () => void;
};

const searchIconContainer: SxProps = {
  mr: 1,
  mt: 0.5,
  color: 'customGrey.dark'
};

/**
 * @deprecated Use 'SearchInput' from 'ui/SearchInput' instead
 */
export const SearchInput = ({
  onClear,
  isLoading,
  ...props
}: SearchInputProps) => {
  return (
    <Input
      placeholder="Search"
      InputProps={{
        startAdornment: (
          <Box sx={searchIconContainer}>
            <SearchIcon fontSize="small" />
          </Box>
        ),
        endAdornment: (
          <Box width={40}>
            {isLoading ? (
              <Loading size={20} />
            ) : (
              <IconButton size="small" onClick={onClear}>
                <CancelOutlinedIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        )
      }}
      {...props}
    />
  );
};
